import cn from 'classnames';

import {StatusColor} from 'types';

import styles from './StatusBadge.module.scss';

interface Props {
  children: React.ReactNode;
  color: StatusColor;
  className?: string;
}

function StatusBadge({children, color, className}: Props) {
  return (
    <div className={cn(styles.root, styles[`--${color}`], className)}>
      {children}
    </div>
  );
}

export default StatusBadge;
